import React, { useRef } from 'react';
import { Grid, TableCell, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import TimeEntryFields from '../../components/time-entry-fields';
import { ETaskStatus } from '../../enums/task-status.enum';

interface ICustomTableColumnCellProps {
  dataOfDate?: any;
  status?: ETaskStatus;
  content?: any;
  sticky?: any;
  className?: any;
  planHours?: string;
  colSpan?: any;
  isEditable?: boolean;
  isActive?: boolean;
  isTaskNameColumn?: boolean;
  isCommonTask?: boolean;
  isHeaderRow?: boolean;
  totalColumnStyle?: boolean;
  onEditClick?: () => void;
  onTimeChange?: (updatedTime: any) => void;
  onIsActiveChange?: (isActive: boolean) => void;
  description?:string;
}

const CustomTableColumnCell: React.FC<ICustomTableColumnCellProps> = ({
  dataOfDate,
  status,
  content,
  sticky,
  className,
  colSpan,
  isEditable,
  isActive,
  isTaskNameColumn,
  isCommonTask,
  isHeaderRow,
  planHours,
  totalColumnStyle,
  onEditClick,
  onTimeChange,
  onIsActiveChange,
  description
}) => {
  const [tooltipWidth, setTooltipWidth] = React.useState<number>(140);
  const screenWidth = window.innerWidth;

  const generateStatus = (status: ETaskStatus) => {
    let tStatus = '';
    if (status === ETaskStatus.TO_DO) {
      return tStatus = 'To Do';
    } else if (status === ETaskStatus.IN_PROGRESS) {
      return tStatus = 'In Progress';
    } else if (status === ETaskStatus.ON_HOLD) {
      return tStatus = 'On Hold';
    } else if (status === ETaskStatus.COMPLETED) {
      return tStatus = 'Completed';
    }
    return tStatus;
  }

  const generateColorStatus = (status: ETaskStatus) => {
    let tStatus = '#007BFF';
    if (status === ETaskStatus.TO_DO) {
      return tStatus = '#007BFF';
    } else if (status === ETaskStatus.IN_PROGRESS) {
      return tStatus = '#FFC107';
    } else if (status === ETaskStatus.ON_HOLD) {
      return tStatus = '#FF4C4C';
    } else if (status === ETaskStatus.COMPLETED) {
      return tStatus = '#28A745';
    }
    return tStatus;
  }

  React.useEffect(() => {
    if (screenWidth < 1900) {
      setTooltipWidth(140);
    } else {
      setTooltipWidth(250);
    }
  }, [screenWidth, isTaskNameColumn]);

  return (
    <TableCell
      colSpan={colSpan ? colSpan : 0}
      className={className ? className : ''}
      style={{
        background: totalColumnStyle ? 'rgba(98, 103, 253, 0.2) !important': isCommonTask ? '#f8f9f9' : 'white',
        whiteSpace: 'nowrap',
        alignItems: 'center',
        color: '#232C68',
        fontSize: '11px',
        position: sticky ? 'sticky' : 'relative',
        left: sticky ? 0 : '',
        zIndex: sticky ? 10 : 1,
        borderRight: '1px solid rgba(34, 51, 84, 0.1)',
        borderBottom: '1px solid rgba(34, 51, 84, 0.1)',
        fontWeight : totalColumnStyle ? '900' : ''

      }}
    >
      <Grid
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:
            isEditable || isTaskNameColumn ? 'space-between' : 'center'
        }}
      >
        {isActive ? (
          <TimeEntryFields time={dataOfDate} onTimeChange={onTimeChange} onIsActiveChange={onIsActiveChange} />
        ) : (
          <>
            {isTaskNameColumn && (
              <Tooltip
                title={
                    <Typography
                      style={{
                        fontSize: '11px',
                        wordBreak: 'break-word'
                      }}
                    >
                      {content}
                      {planHours && ( <br />)}
                      {planHours && (
                        <span style={{
                          fontSize: '10px',
                          lineHeight: '14px'

                        }}>
                          {planHours && ('(Pl. Hrs : ' + planHours + ')')}
                        </span>)}
                      <br />
                      <span style={{
                        fontSize: '10px',
                        color: generateColorStatus(status),
                        fontWeight: 'bold',
                      }}>
                        {generateStatus(status)}
                      </span>
                    </Typography>
                }
                arrow
              >
                <Typography
                  paddingBottom="0.25rem"
                  paddingTop="0.5rem"
                  variant="body2"
                  style={{
                    fontSize: '11px',
                    maxWidth: tooltipWidth,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    marginLeft:'10px',
                    ...(isCommonTask && { margin: '5px 0 10px 2.4rem' })
                  }}
                  gutterBottom
                >
                  <span>{content}</span>
                  <br />
                  {planHours && (
                    <span style={{
                    fontSize: '10px',
                    lineHeight:'14px'
               
                  }}>
                   {planHours && ('(Pl. Hrs : '+ planHours+')')}
                  </span>)}

                  <span style={{
                    fontSize: '10px',
                    color: generateColorStatus(status),
                    fontWeight: 'bold',
                    marginLeft: planHours ? '5px' :'0px'
                  }}>
                    {generateStatus(status)}
                  </span>

                 
                
                </Typography>
              </Tooltip>
            )}
              {!isTaskNameColumn && (
                <>
                  {description != null || (isCommonTask && description != null) ? (
                    <Tooltip
                      title={
                        <Typography
                          style={{
                            fontSize: '11px',
                            wordBreak: 'break-word',
                          }}
                        >

                          <span style={{
                            fontSize: '10px',
                            lineHeight: '14px'

                          }}>
                            {description}
                          </span>
                        </Typography>
                      }
                      arrow
                    >
                      <Typography
                        paddingBottom="0.25rem"
                        paddingTop="0.5rem"
                        variant="body2"
                        style={{ fontSize: '11px', whiteSpace: 'nowrap', fontWeight: isHeaderRow ? totalColumnStyle ? '900' : '700' : '500' ,width: '100%', display: 'flex'}}
                        gutterBottom
                      >
                        {content !== '0h 0m' ? <>
                          <span style={{ fontWeight: '900' }}>{content}</span>
                        </> : <>{content}</>}
                      </Typography>
                    </Tooltip>
                  ) : (

                    <Typography
                      paddingBottom="0.25rem"
                      paddingTop="0.5rem"
                      variant="body2"
                      style={{ fontSize: '11px', whiteSpace: 'nowrap', fontWeight: isHeaderRow ? totalColumnStyle ? '900' : '700' : '500' }}
                      gutterBottom
                    >
                      {content !== '0h 0m' ? <>
                        <span style={{ fontWeight: '900' }}>{content}</span>
                      </> : <>{content}</>}
                    </Typography>
                  )}
                </>
              )}
              {isEditable && (
                <>
                  {description != null || (isCommonTask && description != null) ? (

                    <Tooltip
                      title={
                        <Typography
                          style={{
                            fontSize: '11px',
                            wordBreak: 'break-word',
                          }}
                        >

                          <span style={{
                            fontSize: '10px',
                            lineHeight: '14px'

                          }}>
                            {description}
                          </span>
                        </Typography>
                      }
                      arrow
                    >


                      <EditIcon
                        sx={{
                          fontSize: '16px',
                          cursor:
                            (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? 'pointer' : 'default',
                          opacity: (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? 1 : 0.5
                        }}
                        onClick={
                          (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? onEditClick : undefined
                        }

                      />
                    </Tooltip>
                  ) : (
                    <EditIcon
                      sx={{
                        fontSize: '16px',
                        cursor:
                          (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? 'pointer' : 'default',
                        opacity: (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? 1 : 0.5
                      }}
                      onClick={
                        (status !== ETaskStatus.COMPLETED) && (status !== ETaskStatus.ON_HOLD) ? onEditClick : undefined
                      }

                    />

                  )}



                </>
              )}
          </>
        )}
      </Grid>
    </TableCell>
  );
};

export default CustomTableColumnCell;
